// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedMicorMono_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.72622 17.324L9.50434 9.54589L9.15079 12.7279L5.96884 16.6169L7.38304 18.0311L11.2721 14.8492L14.4541 14.4956L6.67594 22.2738L8.09014 23.688L17.4261 14.352L19.7573 9.19234L18.7646 8.19956L20.8181 4.59623L24 0.707103L23.2929 0L19.4038 3.18196L15.8683 5.30327L14.8076 4.24262L9.64797 6.57385L0.31201 15.9098L1.72622 17.324ZM17.3504 9.61376L15.5147 13.435L10.565 8.48524L14.3862 6.64961L17.3504 9.61376Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M22.8282 6.67733L17.8479 8.76815L23.232 14.1522L25.3228 9.17191L22.8282 6.67733ZM21.9542 15.7028L18.4187 16.4099L14.5295 19.5919L12.4082 17.4706L15.5903 13.5814L16.2973 10.046L2.15518 24.1881L0.740967 22.7739L16.2973 7.21751L23.3684 4.38909L24.0755 5.09619L26.9039 3.68198L30.793 0.5L31.5001 1.20711L28.3181 5.09619L26.9039 7.92462L27.611 8.63173L24.7826 15.7028L9.22625 31.2591L7.81203 29.8449L21.9542 15.7028Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedMicorMono is a generated icon component.
 */
let IconMedMicorMono = IconMedMicorMono_1 = class IconMedMicorMono extends IconBaseElement {
    render() {
        return html `${IconMedMicorMono_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedMicorMono.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconMedMicorMono = IconMedMicorMono_1 = __decorate([
    customElement('zui-icon-med-micor-mono')
], IconMedMicorMono);
export { IconMedMicorMono };
